module.exports = __webpack_public_path__ + "img/35fbbb0a22e8ecb07e46ef308c9146ef.png";